export const geoApiOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "bb2970a0admshc24b61c53fd8c49p1a999bjsnca8e6fbf87d6",
    "X-RapidAPI-Host": "wft-geo-db.p.rapidapi.com",
  },
};

export const Get_URL = "https://wft-geo-db.p.rapidapi.com/v1/geo";

export const Weather_API_URL = "https://api.openweathermap.org/data/2.5";

export const API_KEY = "1f5d59bff4cda49e3fecc1ead0a115ab";
